import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/chevronRight.tsx
var ChevronRight = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M10 6L16 12L10 18",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M9.46972 5.46972C9.74432 5.19512 10.179 5.17765 10.4736 5.41796L10.5303 5.46972L16.5303 11.4697L16.624 11.584C16.7055 11.7063 16.75 11.8508 16.75 12C16.75 12.1491 16.7055 12.2937 16.624 12.416L16.5303 12.5303L10.5303 18.5303C10.2374 18.8232 9.76261 18.8232 9.46972 18.5303C9.17683 18.2374 9.17683 17.7626 9.46972 17.4697L14.9394 12L9.46972 6.53027L9.41796 6.47363C9.17765 6.17905 9.19512 5.74433 9.46972 5.46972Z",
		fill: "currentColor"
	})
});
//#endregion
export { ChevronRight };
